import { createSlice, PayloadAction } from '@reduxjs/toolkit';

// models
import QuotationsMeasurements from '../../../models/Chart/QuotationsMeasurements';
import SalesTrend from '../../../models/Chart/SalesTrend';

export type MetricState = {
  quotationsMeasurements: QuotationsMeasurements[];
  salesTrend: SalesTrend[];
};

export const initialState: MetricState = {
  quotationsMeasurements: [],
  salesTrend: [],
};

const metricSlice = createSlice({
  name: 'metric',
  initialState,
  reducers: {
    updateQuotationsMeasurements: (
      state,
      action: PayloadAction<QuotationsMeasurements[]>,
    ) => {
      state.quotationsMeasurements = action.payload;
    },
    updateSalesTrend: (state, action: PayloadAction<SalesTrend[]>) => {
      state.salesTrend = action.payload;
    },
  },
});

export const { updateQuotationsMeasurements, updateSalesTrend } =
  metricSlice.actions;

export default metricSlice.reducer;
